define.alias("ember-composable-helpers/helpers/from-entries", "settings/helpers/from-entries");